import {
  Button,
  CircularProgress,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useState } from "react";
import CircleIcon from "@mui/icons-material/Circle";
import PanoramaFishEyeIcon from "@mui/icons-material/PanoramaFishEye";
import AddAdressModal from "./AddAdressModal";
import { useGetUserApiQuery } from "../../../../../Store/Slices/rtk";
import { GradientBorderBox } from "../../../../../Components";

export default function CartConfirmAddress({
  handleOrderEntries,
  orderEntries,
  handleAddressChange,
  addressLoading,
}) {
  const theme = useTheme();

  const [openAddressModal, setOpenAddressModal] = useState(false);

  const isMobile = useMediaQuery("(max-width:600px)");

  const profile = useGetUserApiQuery(undefined, {
    refetchOnMountOrArgChange: true,
  });
  const user = profile?.data?.data;

  // const itemsr = [
  //   { name: "محل کسب", location: "خیابان ۱ بلوار ۳ کوچه۷ پلاک ۹۰" },
  //   { name: "محل کار", location: "خیابان ۱ بلوار ۳ کوچه۷ پلاک ۹۰" },
  //   { name: "خانه ", location: "خیابان ۱ بلوار ۳ کوچه۷ پلاک ۹۰" },
  // ];

  // text remover
  const spliter = (word, limit) => {
    const nums = word.split(" ").slice(0, limit);
    const add = nums.length >= limit ? "..." : "";
    return nums.join(" ") + add;
  };

  const items = user?.address?.map((e, index) => {
    return (
      <Stack
        key={index}
        onClick={() => handleAddressChange(e?.code)}
        direction={"row"}
        sx={{
          borderRadius: "4px",
          gap: "1rem",
          py: ".5rem",
          px: ".7rem",
          width: "100%",
          direction: "rtl",
          justifyContent: "space-between",
          cursor: "pointer",
          position: "relative",
        }}
      >
        <Stack direction={"row"} sx={{ width: "90%", alignItems: "center" }}>
          <Typography
            sx={{
              width: { xs: "30%", md: "20%" },
              fontWeight: "bold",
              color: theme.palette.primary.main,
            }}
          >
            {e?.name}
          </Typography>
          <Typography
            sx={{ fontSize: ".8rem", color: theme.palette.background.white }}
          >
            {" "}
            {isMobile
              ? spliter(e?.address_line, 5)
              : spliter(e?.address_line, 12)}
          </Typography>
        </Stack>
        <Stack
          sx={{
            alignItems: "end",
            width: "10%",
          }}
        >
          {addressLoading ? (
            <CircularProgress color="primary" size={"22px"} />
          ) : orderEntries?.selectedAddress == e?.code ? (
            <CircleIcon sx={{ color: theme.palette.primary.main }} />
          ) : (
            <PanoramaFishEyeIcon sx={{ color: theme.palette.primary.main }} />
          )}
        </Stack>
        <GradientBorderBox radius=".5rem" inside={true} />
      </Stack>
    );
  });
  return (
    <Stack
      sx={{ color: theme.palette.secondary.main, width: "100%", gap: "1.5rem" }}
    >
      <Stack
        direction={"row"}
        sx={{
          direction: "rtl",
          justifyContent: "space-between",
        }}
        alignItems={"center"}
      >
        <Typography
          sx={{
            fontSize: "1.4rem",
            color: theme.palette.primary.main,
          }}
        >
          آدرس ها
        </Typography>
        <Button
          onClick={() => setOpenAddressModal(true)}
          sx={{
            bgcolor: theme.palette.primary.main,
            color: theme.palette.background.default,
          }}
        >
          افزودن آدرس
        </Button>
      </Stack>
      <Stack
        sx={{
          width: "100%",
          gap: ".7rem",
          maxHeight: { xs: "320px", md: "330px", xl: "350px" },
          overflowY: "auto",
        }}
      >
        {items?.length > 0 ? (
          items
        ) : (
          <Typography
            sx={{
              textAlign: "center",
              color: theme.palette.primary.lowOpacity,
            }}
          >
            هنوز آدرسی موجود نیست
          </Typography>
        )}
      </Stack>
      <AddAdressModal
        openModal={openAddressModal}
        setOpenModal={setOpenAddressModal}
        refetchGet={profile.refetch}
      />
    </Stack>
  );
}
